import React, { useState } from 'react';
interface FlipCardProps {
  frontTitle: string;
  backTitle: string;
  link: string;
}
const FlipCard: React.FC<FlipCardProps> = ({
  frontTitle,
  backTitle,
  link
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const handleClick = () => {
    window.location.href = link;
  };
  return <div className="relative w-full aspect-square cursor-pointer" style={{
    perspective: '1000px'
  }} onMouseEnter={() => setIsFlipped(true)} onMouseLeave={() => setIsFlipped(false)} onClick={handleClick} data-id="element-231">
      <div className="relative w-full h-full transition-transform duration-700" style={{
      transformStyle: 'preserve-3d',
      transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
    }} data-id="element-232">
        {/* Front */}
        <div className="absolute w-full h-full bg-white flex flex-col items-center justify-center p-8" style={{
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden'
      }} data-id="element-233">
          <div className="mb-4" data-id="element-234">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700" data-id="element-235">
              <polyline points="18 15 12 9 6 15" data-id="element-236"></polyline>
            </svg>
          </div>
          <h3 className="text-xl text-orange-500 text-center font-normal" data-id="element-237">
            {frontTitle}
          </h3>
        </div>

        {/* Back */}
        <div className="absolute w-full h-full bg-white flex items-center justify-center p-8" style={{
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        transform: 'rotateY(180deg)'
      }} data-id="element-238">
          <h3 className="text-xl text-orange-500 text-center font-normal" data-id="element-239">
            {backTitle}
          </h3>
        </div>
      </div>
    </div>;
};
export const CoachingPage: React.FC = () => {
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-240">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-241">
          <div data-id="element-242">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6" data-id="element-243">
              „Wenn zwei Menschen immer dasselbe denken, ist einer von ihnen
              überflüssig."
            </h1>
            <p className="text-gray-700" data-id="element-244">Winston Churchill</p>
          </div>
          <div className="flex justify-center" data-id="element-245">
            <img src="https://cdn.magicpatterns.com/uploads/1FWp3N1Ev6YLBZW59XLBwx/Eva-Schifferer-Coaching-Puzzle.png" alt="Coaching Puzzle" className="max-h-96 object-contain" data-id="element-246" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-247">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-248">
          <div data-id="element-249">
            <p className="mb-6 text-base leading-relaxed" data-id="element-250">
              Um Sicherheit über den nächsten Schritt zu erlangen, stößt
              Feedback aus dem eigenen Netzwerk schnell an Grenzen – denn jeder
              hat auch eigene Interessen. Hier braucht es in Zeiten der
              Veränderung einen neutralen und inspirierenden Sparringspartner.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-251">
              Oft besteht ein diffuses Gefühl, dass etwas anders sein sollte –
              aber was? Und vor allem: wie? Coaching als zeitlich begrenzte und
              höchst individuelle Maßnahme unterstützt Sie in einfachen und
              strukturierten Schritten schnellen Wandel zu spüren.
            </p>
          </div>
          <div data-id="element-252">
            <p className="mb-6 text-base leading-relaxed" data-id="element-253">
              Sie erkennen Ihre wirklichen Stärken, erweitern Handlungsoptionen
              und finden über ehrliches Feedback Lösungen für Herausforderungen.
              Ein besonderes Augenmerk neben der Veränderung liegt auf den
              Dingen, die es zu bewahren gilt.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-254">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-255">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-256">
          <FlipCard frontTitle="Karrierecoaching" backTitle="Mit personal branding zum nächsten Schritt" link="/coaching/karriere" data-id="element-257" />
          <FlipCard frontTitle="Führungscoaching" backTitle="Erfolgreich und authentisch führen" link="/coaching/fuehrung" data-id="element-258" />
        </div>
      </section>
    </>;
};